<template>
    <div>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item>
                    <i class='el-icon-lx-cascades'></i> 司机管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container'>
            <div class='handle-box'>


                <el-input v-model='query.name' placeholder='用户名' class='handle-input mr10'
                          style='width: 160px'></el-input>
                <el-button type='primary' icon='el-icon-search' @click='handleSearch'>查询</el-button>
                <el-button type='primary' icon='el-icon-plus' @click='handleAdd'>添加</el-button>
            </div>
            <el-table
                :data='tableData'
                border
                class='table'
                ref='multipleTable'
                header-cell-class-name='table-header'
            >

                <el-table-column label='序号' align='center' :index='indexMethod' type='index' width='40'>
                </el-table-column>
                <el-table-column type='selection' width='55' align='center' v-if='false'></el-table-column>
                <el-table-column prop='name' label='用户名' align='center'></el-table-column>

                <el-table-column prop='concatName' label='用户头像' align='center'>
                    <template slot-scope='scope'>

                        <el-image
                            style='width: 80px; height: 80px'
                            :src='scope.row.photoUrl'

                            :preview-src-list='[scope.row.photoUrl]'
                            :fit='fit'>

                            <div slot="error" class="image-slot" style='display: flex;justify-content: center;align-items: center;height: 100%'>
                                <div >暂无图片</div>
                            </div>

                        </el-image>
                    </template>
                </el-table-column>

                <!--                <el-table-column prop='area' label='性别' align='center'>-->
                <!--                    <template slot-scope='scope'>{{ scope.row.sex === 0 ? '女' : '男' }}</template>-->

                <!--                </el-table-column>-->

                <!--                <el-table-column prop='area' label='出生年月' align='center'>-->
                <!--                    <template slot-scope='scope'>{{ scope.row.birthday }}</template>-->

                <!--                </el-table-column>-->

                <el-table-column prop='createTime' label='联系方式' align='center'>
                    <template slot-scope='scope'>{{ scope.row.phone }}</template>

                </el-table-column>
                <el-table-column prop='createTime' label='角色' align='center'>
                    <template slot-scope='scope'>{{ scope.row.role==0?"班组长":"司机" }}</template>

                </el-table-column>
                <el-table-column prop='createTime' label='创建时间' align='center'>
                    <template slot-scope='scope'>{{ scope.row.createTime }}</template>

                </el-table-column>
                <el-table-column label='操作' width='180' align='center'>
                    <template slot-scope='scope'>
                        <el-button
                            type='text'
                            icon='el-icon-edit'
                            @click='handleEdit(scope.$index, scope.row)'
                        >修改密码
                        </el-button>
                        <el-button
                            type='text'
                            icon='el-icon-delete'
                            class='red'
                            @click='handleDelete(scope.$index, scope.row)'
                        >删除
                        </el-button>
                        <!--                        <el-button-->
                        <!--                            type='text'-->
                        <!--                            class='blue'-->
                        <!--                            @click='handleForbidden(scope.$index, scope.row)'-->
                        <!--                        >{{ scope.row.status === 0 ? '禁用' : '解除禁用' }}-->
                        <!--                        </el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination'>
                <el-pagination
                    background
                    layout='total, prev, pager, next'
                    :current-page='query.pageIndex'
                    :page-size='query.pageSize'
                    :total='pageTotal'
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog title='修改密码' :visible.sync='editVisible' width='40%'>


            <el-form ref='form' :model='form' label-width='120px'>

                <el-form-item label='新密码'>
                    <el-input v-model='form.newPwd' maxlength='36' placeholder='请输入新密码'></el-input>
                </el-form-item>
                <el-form-item label='确认新密码'>
                    <el-input v-model='form.rePwd' maxlength='36' placeholder='请输入确认新密码'></el-input>

                </el-form-item>


            </el-form>

            <span slot='footer' class='dialog-footer'>
                <el-button @click='editVisible = false'>取 消</el-button>
                <el-button type='primary' @click='saveEdit'>更 新</el-button>
            </span>
        </el-dialog>

        <!-- 添加用户 -->
        <el-dialog title='添加司机' :visible.sync='addVisible' width='40%'>


            <el-form ref='form' :model='form' label-width='120px'>

                <el-form-item label='用户名'>
                    <el-input v-model='createForm.name' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='密码'>
                    <el-input v-model='createForm.pwd' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='联系方式'>
                    <el-input v-model='createForm.phone' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='成员类型'>
                    <el-select v-model='createForm.role' placeholder='请选择成员类型'
                               style='width: 140px;margin-right: 20px'>
                        <el-option
                            v-for='item in roleOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label='头像'>
                    <el-upload
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='[createForm.photoUrl]'
                        limit='1'
                        action='https://jsonplaceholder.typicode.com/posts/'
                        :http-request='uploadFileCovenant'
                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                </el-form-item>

            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='addVisible = false'>取 消</el-button>
                <el-button type='primary' @click='addUserHttp' :loading="submitLoading" :disabled='submitLoading' >确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { formatDate, formatDates } from '@/utils/formatDate';

export default {
    name: 'basetable',
    data() {
        return {
            submitLoading:false,
            radio: '1',
            fileList: [],
            workType: '',
            value: [],
            options: [],
            query: {
                name: '',
                educationRank: '',
                pageIndex: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible: false,
            cityOptions: [],
            cityIds: [],
            workTypeIds: [],
            roleOptions: [{"value":"0","label":"班组长"}, {"value":"1","label":"司机"}],


            createForm: {
                'concatPhone': '',
                'concatName': '',
                'name': '',
                'covenantUrl': '',
                'legalPersonUrl': '',
                'orzUrl': '',
                'isCustomerService': '1',
                'provinceId': '',
                'cityId': ''

            }
            ,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1

        };
    },
    created() {
        this.getData();
        // this.getCity();
    },


    methods: {
        indexMethod(index) {
            return index + 1;
        },
        handlePreview(file) {

        },
        uploadFileCovenant(file) {
            let that = this;
            this.http.postFile('/local_file', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);
                    that.form.photoUrls = [{ url: that.http.getDownLoadUrl() + res.data.data[0] }];

                    that.form.photoUrl = that.http.getDownLoadUrl() + res.data.data[0];
                    that.createForm.photoUrl = that.http.getDownLoadUrl() + res.data.data[0];

                }
            }, err => {
                // 出现错误时的处理
            });
        },
        uploadFileLegalPerson(file) {
            let that = this;
            this.http.postFile('/uploadFile', file.file).then(res => {
                // 上传成功后的处理
                console.log(res.data);
                if (res.data.code == 0) {
                    that.createForm.legalPersonUrl = res.data.data;
                    that.form.legalPersonUrl = res.data.data;
                }
            }, err => {
                // 出现错误时的处理
                console.log(res);
            });
        },
        uploadFileOrzUrl(file) {
            let that = this;
            this.http.postFile('/uploadFile', file.file).then(res => {
                // 上传成功后的处理
                console.log(res.data);
                if (res.data.code == 0) {
                    that.createForm.orzUrl = res.data.data;
                    that.form.orzUrl = res.data.data;

                }
            }, err => {
                // 出现错误时的处理
                console.log(res);
            });
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type.includes('image');
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('文件只能是图片格式');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        }
        ,
        // 获取 easy-mock 的模拟数据
        getData() {
            let that = this;
            if (this.workType.length != 0) {
                this.query.workType = this.workType[2];
            }


            this.http.get('/user/getUserList', this.query).then(res => {
                    if (res.code == 0) {
                        that.tableData = res.data.records;
                        that.pageTotal = parseInt(res.data.total);
                        this.$message.success('获取数据成功');

                    }
                },
                err => {

                });
        },


        getCity() {
            let that = this;


            this.http.getToken('serviceProvider/getCity', this.query).then(res => {
                    if (res.code == 0) {
                        that.options = res.data;

                    }
                },
                err => {

                });
        },
        // 触发搜索按钮
        handleSearch() {
            this.query.pageIndex = 1;
            this.getData();

        },
        delUserHttp(id) {
            let that = this;
            this.http.postToken('user/delXcxUserById', { 'id': id, 'status': 1 }).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,

        editUserHttp(params) {
            let that = this;

            this.http.postToken('user/updateUserPwdByid', params).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        this.editVisible = false;
                        that.$message.success('编辑成功');
                    }
                },
                err => {

                });
        }
        ,
        handleAdd() {
            this.createForm = {};
            this.addVisible = true;
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id);

                })
                .catch(() => {
                });
        },

        addUser() {
            this.createForm = {};
            this.value = [];
            this.addVisible = true;


        },

        addUserHttp() {
           this.submitLoading= true;
            let that = this;
            this.http.postToken('user/createClientAccount', this.createForm).then(res => {
                if (res.code === 0) {
                    that.getData();
                    that.addVisible = false;
                }
                // 设置一个1000毫秒后执行的定时任务
                setTimeout(function() {
                    that.submitLoading=false;
                }, 1000);
            });
        }
        ,
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
            }
            this.$message.error(`删除了${str}`);
            this.multipleSelection = [];
        },
        //禁用
        handleForbidden(index, row) {
            // 二次确认删除
            console.log(index);
            console.log(row.uid);
            let that = this;
            let params = {};
            let msg = '';
            if (row.status == 0) {
                msg = '确定要' + '禁用' + '吗？';
                params = { 'id': row.id, 'status': 2 };
            } else {
                msg = '确定要' + '解除禁用' + '吗？';
                params = { 'id': row.id, 'status': 0 };
            }

            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.postToken('serviceProvider/updateStatus', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        // 编辑操作
        handleEdit(index, row) {
            this.form = {};
            this.form.id = row.id;

            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {

            this.editUserHttp(this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}

.avatar-uploader {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
